module.exports = __webpack_public_path__ + "static/media/logo_businees_partner.02922f16.svg";